import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';
import React from 'react';

export const Wrapper = styled('div', React.forwardRef)`
    display: flex;
    & > * {
        width: auto !important;
    }
`;

export const DropdownHead = styled('div')<{ $isShowMenu: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    color: ${({ $isShowMenu }) => ($isShowMenu ? COLORS.neutral_90 : COLORS.neutral_50)};
    cursor: pointer;

    svg {
        transition: all 0.3s ease;
        transform: ${({ $isShowMenu }) => ($isShowMenu ? 'rotate(180deg)' : 'rotate(0deg)')};
    }

    &:hover {
        color: ${COLORS.neutral_80};
    }

    &:active {
        color: ${COLORS.neutral_90};
    }
`;
